(function ($, window) {
  $resultSearchNews = $('.mcl-news-template');
  if ($resultSearchNews.length > 0) {
    $newsFilters = $resultSearchNews.find('.mcl-news-filters');
    $cptType = $resultSearchNews.attr('data-type');
    $form = $resultSearchNews.find('form');
    $resultSearchNews.each(function (i, el) {

      $pagination = $(el).find('.mcl-pagination');
      var url = ajax_url,
        data = {
          nextPage: 1,
          action: 'paginationNews',
          cptType: $cptType,
          postsPerPage: $resultSearchNews.attr('data-post-per-page')
        };

      $.post(url, data, function (resp) {
        var respObj = JSON.parse(resp);
        pagination(1, parseInt(respObj.maxNumPages));
      });

      $(el).on('click touch', '.mcl-page', function (e) {
        e.preventDefault();

        const order = $form.find('input[name=sort-order]').val();

        var terms = $newsFilters.find('.mcl-pill').map(function () {
          if ($(this).hasClass('active')) return $(this).attr('data');
        }).get();

        var url = ajax_url,
          data = {
            nextPage: parseInt($(e.target).html()),
            action: 'paginationNews',
            cptType: $cptType,
            order: order,
            terms: terms,
            postsPerPage: $resultSearchNews.attr('data-post-per-page')
          };

        $.post(url, data, function (resp) {
          var respObj = JSON.parse(resp);
          $resultWrapper = $resultSearchNews.find('.mcl-results').find('.mcl-resuls-wrapper');
          $resultWrapper.empty();
          $resultWrapper.html(respObj.markup);
          $pagination.attr('data-curr-page', respObj.nextPage);
          $pagination.find('.mcl-page').remove();
          pagination(parseInt(respObj.nextPage), parseInt(respObj.maxNumPages));
          $(e.target).addClass('active');
          if (respObj.nextPage === '1')
            $pagination.find('.mcl-prev').addClass('disabled');
          else
            $pagination.find('.mcl-prev').removeClass('disabled');
          if (respObj.hasNext)
            $pagination.find('.mcl-next').removeClass('disabled');
          else
            $pagination.find('.mcl-next').addClass('disabled');

          $('html, body').animate({
            scrollTop: $newsFilters.offset().top - 100
          }, 1000);
        });
      });

      $(el).on('click touch', '.mcl-prev', function (e) {
        e.preventDefault();

        const order = $form.find('input[name=sort-order]').val();

        var terms = $newsFilters.find('.mcl-pill').map(function () {
          if ($(this).hasClass('active')) return $(this).attr('data');
        }).get();

        var url = ajax_url,
          data = {
            nextPage: parseInt($pagination.attr('data-curr-page')) - 1,
            action: 'paginationNews',
            cptType: $cptType,
            order: order,
            terms: terms,
            postsPerPage: $resultSearchNews.attr('data-post-per-page')
          };

        $.post(url, data, function (resp) {
          var respObj = JSON.parse(resp);
          $resultWrapper = $resultSearchNews.find('.mcl-resuls-wrapper');
          $resultWrapper.empty();
          $resultWrapper.html(respObj.markup);
          $pagination.attr('data-curr-page', respObj.nextPage);
          $pagination.find('.mcl-page').remove();
          pagination(parseInt(respObj.nextPage), parseInt(respObj.maxNumPages));
          $pagination.find('.mcl-page:contains(' + respObj.nextPage + ')').addClass('active');
          if (respObj.nextPage === '1')
            $pagination.find('.mcl-prev').addClass('disabled');
          else
            $pagination.find('.mcl-prev').removeClass('disabled');
          if (respObj.nextPage === '1' && respObj.hasNext)
            $pagination.find('.mcl-next').removeClass('disabled');
          else
            $pagination.find('.mcl-next').addClass('disabled');

          $('html, body').animate({
            scrollTop: $newsFilters.offset().top - 100
          }, 1000);

          return false;
        });
      });

      $(el).on('click touch', '.mcl-next', function (e) {
        e.preventDefault();

        const order = $form.find('input[name=sort-order]').val();

        var terms = $newsFilters.find('.mcl-pill').map(function () {
          if ($(this).hasClass('active')) return $(this).attr('data');
        }).get();

        var url = ajax_url,
          data = {
            nextPage: parseInt($pagination.attr('data-curr-page')) + 1,
            action: 'paginationNews',
            cptType: $cptType,
            order: order,
            terms: terms,
            postsPerPage: $resultSearchNews.attr('data-post-per-page')
          };

        $.post(url, data, function (resp) {
          var respObj = JSON.parse(resp);
          $resultWrapper = $resultSearchNews.find('.mcl-resuls-wrapper');
          $resultWrapper.empty();
          $resultWrapper.html(respObj.markup);
          $pagination.attr('data-curr-page', respObj.nextPage);
          $pagination.find('.mcl-page').remove();
          pagination(parseInt(respObj.nextPage), parseInt(respObj.maxNumPages));
          $pagination.find('.mcl-page:contains(' + respObj.nextPage + ')').addClass('active');
          if (respObj.hasNext)
            $pagination.find('.mcl-next').removeClass('disabled');
          else
            $pagination.find('.mcl-next').addClass('disabled');

          $pagination.find('.mcl-prev').removeClass('disabled');

          $('html, body').animate({
            scrollTop: $newsFilters.offset().top - 100
          }, 1000);

          return false;
        });
      });

      $newsFilters.on('click touch MDCSelect:change', '.mcl-pill, .mdc-select', function (e) {
        e.preventDefault();
        $form = $newsFilters.find('form');

        const order = $form.find('input[name=sort-order]').val();

        var terms = $newsFilters.find('.mcl-pill').map(function () {
          if ($(this).hasClass('active')) return $(this).attr('data');
        }).get();

        var url = ajax_url,
          data = {
            nextPage: 1,
            action: 'paginationNews',
            cptType: $cptType,
            order: order,
            terms: terms,
            postsPerPage: $resultSearchNews.attr('data-post-per-page')
          };

        $.post(url, data, function (resp) {
          var respObj = JSON.parse(resp);
          $resultWrapper = $resultSearchNews.find('.mcl-resuls-wrapper');
          $resultWrapper.empty();
          $resultWrapper.html(respObj.markup);
          $pagination.attr('data-curr-page', respObj.nextPage);
          $pagination.find('.mcl-page').remove();
          $resultSearchNews.find('.mcl-button.show-more-mobile').attr('data', 2);
          if (respObj.maxNumPages > 0) {
            pagination(1, parseInt(respObj.maxNumPages));
            if (respObj.hasNext) {
              $pagination.find('.mcl-next').removeClass('disabled');
              $resultSearchNews.find('.mcl-button.show-more-mobile').show();
            } else {
              $pagination.find('.mcl-next').addClass('disabled');
              $pagination.find('.mcl-prev').addClass('disabled');
              $resultSearchNews.find('.mcl-button.show-more-mobile').hide();
            }
          } else {
            $pagination.find('.mcl-prev').addClass('disabled');
            $pagination.find('.mcl-next').addClass('disabled');
            $("<a class=\"mcl-page text label2 medium\" href=\"#anchor\">No match found</a>").insertBefore($pagination.find('.mcl-next'));
          }

          $('html, body').animate({
            scrollTop: $newsFilters.offset().top - 100
          }, 1000);

          return false;
        });
      });

      // Bottone mostra di più visibile solo su mobile
      $resultSearchNews.on('click', '.mcl-button.show-more-mobile', function (e) {
        e.preventDefault();
        $form = $newsFilters.find('form');

        const order = $form.find('input[name=sort-order]').val();

        var terms = $newsFilters.find('.mcl-pill').map(function () {
          if ($(this).hasClass('active')) return $(this).attr('data');
        }).get();

        var url = ajax_url,
          data = {
            nextPage: $(this).attr('data'),
            action: 'paginationNews',
            cptType: $cptType,
            order: order,
            terms: terms,
            postsPerPage: $resultSearchNews.attr('data-post-per-page')
          };

        $.post(url, data, function (resp) {
          var respObj = JSON.parse(resp);
          $resultWrapper = $resultSearchNews.find('.mcl-resuls-wrapper');
          $resultWrapper.append(respObj.markup);
          $showMoreButton = $resultSearchNews.find('.mcl-button.show-more-mobile');
          $showMoreButton.attr('data', parseInt($showMoreButton.attr('data')) + 1);
          if (!respObj.hasNext)
            $showMoreButton.hide();

          return false;
        });
      });

      // Pagination
      function pagination(c, m) {
        var current = c,
          last = m,
          delta = 1,
          left = current - delta,
          right = current + delta + 1,
          range = [],
          rangeWithDots = [],
          l;

        for (let i = 1; i <= last; i++) {
          if (i == 1 || i == last || i >= left && i < right) {
            range.push(i);
          }
        }

        for (let i of range) {
          if (l) {
            if (i - l === 2) {
              $page = $("<a class=\"mcl-page" + ((l + 1) === c ? 'active' : '') + "\" href=\"#anchor\">" + (l + 1) + "</a>");
              $page.insertBefore($pagination.find('.mcl-next'));
              rangeWithDots.push(l + 1);
            } else if (i - l !== 1) {
              $page = $("<a class=\"mcl-page disabled\" href=\"#anchor\">...</a>");
              $page.insertBefore($pagination.find('.mcl-next'));
              rangeWithDots.push('...');
            }
          }
          $page = $("<a class=\"mcl-page " + (i === c ? 'active' : '') + "\" href=\"#anchor\">" + i + "</a>");
          $page.insertBefore($pagination.find('.mcl-next'));
          rangeWithDots.push(i);
          l = i;
        }
        return rangeWithDots;
      }

      function refreshResult() {
        $resultSearchNews.find('.mcl-page:first').click();
      }

      var transposed = "desktop";
      $(document).ready(function () {
        if ($(window).width() < 1024) {
          transposed = "mobile";
        } else {
          transposed = "desktop";
        }
      })

      $(window).resize(function () {
        if ($(window).width() > 1024 && transposed === "mobile") {
          transposed = "desktop";
          refreshResult();
        } else if ($(window).width() < 1024 && transposed === "desktop") {
          transposed = "mobile";
          refreshResult();
        }
      })
    });
  }
})(jQuery, window);
